import { Phone, MessageSquare, MapPin, FileCheck, Clock } from "lucide-react";
import { Link } from "react-router-dom";
import ScrollReveal from "./ScrollReveal";
import MagneticButton from "./MagneticButton";

const contactPoints = [
  { icon: MessageSquare, label: "Text us for fastest response" },
  { icon: FileCheck, label: "Free estimates available" },
  { icon: MapPin, label: "Local service you can trust" },
];

const CTASection = () => {
  return (
    <section className="py-20 bg-secondary">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center">
          <ScrollReveal>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-secondary-foreground mb-6">
              Get a Free Flooring Estimate
            </h2>
            
            <div className="space-y-4 text-secondary-foreground/90 text-lg leading-relaxed mb-8">
              <p>
                If you're thinking about refinishing your hardwood floors or installing new flooring, we're happy to take a look and talk through your options. We provide honest recommendations, clear communication, and professional results.
              </p>
              <p>
                Call or text to get started — no pressure, no obligation.
              </p>
            </div>
          </ScrollReveal>

          {/* Contact Points */}
          <ScrollReveal delay={0.1}>
            <div className="flex flex-wrap justify-center gap-6 mb-10">
              {contactPoints.map((point, index) => (
                <div
                  key={index}
                  className="flex items-center gap-2 text-secondary-foreground/80"
                >
                  <point.icon className="w-5 h-5" />
                  <span className="font-heading text-sm uppercase tracking-wide">
                    {point.label}
                  </span>
                </div>
              ))}
            </div>
          </ScrollReveal>

          {/* CTAs */}
          <ScrollReveal delay={0.2}>
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
              <MagneticButton>
                <a
                  href="sms:+17192327424"
                  className="btn-cta-primary flex items-center justify-center gap-3 text-lg"
                >
                  <MessageSquare size={22} />
                  Text for Free Estimate
                </a>
              </MagneticButton>
              <MagneticButton>
                <a
                  href="tel:+17192327424"
                  className="bg-primary-foreground text-primary font-heading font-semibold uppercase tracking-wide px-8 py-4 rounded transition-all duration-300 hover:bg-primary-foreground/90 flex items-center justify-center gap-3 text-lg"
                >
                  <Phone size={22} />
                  Call Us
                </a>
              </MagneticButton>
            </div>
          </ScrollReveal>

          {/* Secondary CTA */}
          <ScrollReveal delay={0.3}>
            <div className="mb-8">
              <Link
                to="/contact"
                className="inline-flex items-center text-secondary-foreground/80 hover:text-secondary-foreground font-heading uppercase tracking-wide text-sm transition-colors underline underline-offset-4"
              >
                Or Request an Estimate Online →
              </Link>
            </div>
          </ScrollReveal>

          {/* Reassurance Line */}
          <ScrollReveal delay={0.4}>
            <p className="text-secondary-foreground/70 text-sm flex items-center justify-center gap-2">
              <Clock className="w-4 h-4" />
              We respond promptly and respect your time and your home.
            </p>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
